import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';
import { useMultiSelectionContext } from '../../../providers/MultiSelectionProvider';
import { ListTreeView } from '../../lists/TreeList';
import { LinkObj, NestedChoice, NestedChoices, NestedChoiceTreeNode } from '../LinkInput/types';
import { ListDialogInputModal } from '../ListDialogInput';

interface LinkInputModalDialogListProps {
    link: LinkObj,
    choices: NestedChoices,
    search: string,
}

const LinkInputModalDialogList = ({ link, choices, search }: LinkInputModalDialogListProps) => {
    const [fileShowings, setFileShowings] = useState<NestedChoices>([]);
    const [subChoices, setSubChoices] = useState<NestedChoices>([]);
    const { selection, addSelection } = useMultiSelectionContext();
    const dp = useDataProvider();
    const [childList, setChildList] = useState(false);
    const [selectedNode, setSelectedNode] = useState<NestedChoice>();

    useEffect(() => {
        if ('' === search) {
            setFileShowings(choices)
        } else {
            setFileShowings(choices.filter(x => -1 !== x.name.indexOf(search)))
        }
    }, [choices, link, search])

    const onListItemClick = (f: NestedChoice) => {
        setSelectedNode(f);
        console.log(f, choices);
        if (f.isNested && f.nestedCb) {
            f.nestedCb(dp).then((records) => {
                setChildList(true);
                setSubChoices(records);
            });
        } else {
            addSelection(f);
        }
    }

    const handleSelectClick = (__selection: Array<NestedChoice>) => {
        // addSelection(f);
        addSelection({ ...selectedNode, __selection });
        setChildList(false);
    }

    const ListItem = ({ node }: { node: NestedChoice }) => {
        return <ListItemButton key={`${node.id}`}
            selected={-1 !== selection.indexOf(node)}
            onClick={() => onListItemClick(node)}
        >
            <ListItemIcon>
                {-1 !== selection.indexOf(node)
                    ? <CheckBoxIcon />
                    : <CheckBoxOutlineBlankIcon />
                }
            </ListItemIcon>
            <ListItemText primary={node.name} />
        </ListItemButton>
    }

    const ChildListDialog = () => {
        return <ListDialogInputModal showDialog={true} choices={subChoices}
            label={`Records of ${selectedNode?.name}`}
            handleSelectClick={handleSelectClick}
            handleCloseClick={function (): void {
                setChildList(false);
            }} />
    }

    if ('' === search && link.isTree) {
        return (<>
            <ListTreeView
                data={choices as NestedChoiceTreeNode[]}
                showActionButtons={false}
                listItem={(node: NestedChoiceTreeNode) => <ListItem node={node as any} />} />
            {childList && <ChildListDialog />}
        </>)
    }

    return (<>
        <List>
            {fileShowings.map(node => <ListItem node={node} />)}
        </List>
        {childList && <ChildListDialog />}
    </>)
}
export default LinkInputModalDialogList;